// extracted by mini-css-extract-plugin
export default {"soldComponent":"soldComponent-a2a8","soldSign":"soldSign-3b3c","balloon":"balloon-d2bd"};